<template>
    <div class="index" style="padding-top: 1rem" v-cloak>
        <div class="header acea-row row-center-wrapper">
            <div class="logo">
                <a :href="appUrl ">
                    <img :src="logoUrl" />
                </a>
            </div>
        </div>
        <div>
<!--            <iframe src="http://wayou.github.io/t-rex-runner/" style="height: 100%;width: 100%;"></iframe>-->
            <iframe src="./runner.html" style="height: 250px;width: 100%;"></iframe>
        </div>
        <div style="margin-top:50px;">
            <h1 style="width: 80%;font-size: larger;">
                Sorry,we are in the process of maintaining the website and cannot access it for the time being.
            </h1>
        </div>
    </div>
</template>

<script>
    import {getLogoData} from '@api/public';
    export default {
        name: "maintenancePage",
        data(){
            return{
                logoUrl:'',
                appUrl:''
            }
        },
        methods:{
            getLogo(){
                const vm=this;
                vm.$dialog.loading.open('loading');
                getLogoData().then(res => {
                    vm.logoUrl = res.data.logoUrl;
                }).finally(()=>{
                    vm.$dialog.loading.close();
                });
            }
        },
        mounted:function(){
            this.appUrl=process.env.VUE_APP_URL;
            this.getLogo();
        }
    }
</script>

<style scoped>

</style>